<template>
  <GeneralCard
    :title="title"
    :value="`${formatValue(top3Value)}/${formatValue(totalValue)}`"
    :optionValue="calculateContributionPercentage(top3Value, totalValue)"
  />
</template>

<script>
import GeneralCard from '../../../../components/GeneralCard.vue';
import {
  formatCurrency,
  formatNumber,
  calculateTop3ContributionPercentage as calculateTop3ContributionPercentageStandard,
} from '../shared';

export default {
  name: 'PodiumCard',
  components: {
    GeneralCard,
  },
  props: {
    title: String,
    top3Value: [Number, String],
    totalValue: [Number, String],
    formatType: String,
  },
  methods: {
    formatValue(value) {
      return this.formatType === 'currency'
        ? formatCurrency(value)
        : formatNumber(value);
    },
    formatCurrency(value) {
      return `R$ ${parseFloat(value).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },
    calculateContributionPercentage(top3Value, totalValue) {
      return calculateTop3ContributionPercentageStandard(top3Value, totalValue);
    },
  },
};
</script>

<style scoped></style>
